(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory8sService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory8s: function (parms) {
                return $ihttp.post({
                    method: 2701,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
